module.exports = __webpack_public_path__ + "media/images/top/top_consultant_img_02-d0a30666da581b2b846afb28ed80cc46.png";